import { render, staticRenderFns } from "./WebDocumentViewer.vue?vue&type=template&id=7cbe14dc"
import script from "./WebDocumentViewer.vue?vue&type=script&lang=js"
export * from "./WebDocumentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports